"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stat = [
  "SampleCount",
  "Average",
  "Sum",
  "Minimum",
  "Maximum",
  "p10",
  "p50",
  "p90",
  "p95",
  "p99"
];
exports.period = [
  {
    label: "1 Second",
    value: "1"
  },
  {
    label: "5 Seconds",
    value: "5"
  },
  {
    label: "10 Seconds",
    value: "10"
  },
  {
    label: "30 Seconds",
    value: "30"
  },
  {
    label: "1 Minute",
    value: "60"
  },
  {
    label: "5 Minutes",
    value: "300"
  },
  {
    label: "15 Minutes",
    value: "900"
  },
  {
    label: "1 Hour",
    value: "3600"
  },
  {
    label: "6 Hours",
    value: "21600"
  },
  {
    label: "1 Day",
    value: "86400"
  },
  {
    label: "7 Days",
    value: "604800"
  },
  {
    label: "30 Days",
    value: "2592000"
  }
];
exports.nsMap = {
  "AWS/ApiGateway": {
    MetricNames: [
      "4XXError",
      "5XXError",
      "CacheHitCount",
      "CacheMissCount",
      "Count",
      "IntegrationLatency",
      "Latency"
    ],
    Dimensions: ["ApiName", "Method", "Resource", "Stage"]
  },
  "AWS/AppStream": {
    MetricNames: [
      "ActualCapacity",
      "AvailableCapacity",
      "CapacityUtilization",
      "DesiredCapacity",
      "InUseCapacity",
      "PendingCapacity",
      "RunningCapacity",
      "InsufficientCapacityError"
    ],
    Dimensions: ["Fleet"]
  },
  "AWS/Athena": {
    MetricNames: [],
    Dimensions: []
  },
  "AWS/Billing": {
    MetricNames: ["EstimatedCharges"],
    Dimensions: []
  },
  "AWS/ACMPrivateCA": {
    MetricNames: [
      "CRLGenerated",
      "MisconfiguredCRLBucket",
      "Time",
      "Success",
      "Failure"
    ],
    Dimensions: []
  },
  "AWS/CloudFront": {
    MetricNames: [
      "Requests",
      "BytesDownloaded",
      "BytesUploaded",
      "TotalErrorRate",
      "4xxErrorRate",
      "5xxErrorRate"
    ],
    Dimensions: ["DistributionId", "Region"]
  },
  "AWS/CloudSearch": {
    MetricNames: [
      "SuccessfulRequests",
      "SearchableDocuments",
      "IndexUtilization",
      "Partitions"
    ],
    Dimensions: ["ClientId", "DomainName"]
  },
  "AWS/Events": {
    MetricNames: [
      "DeadLetterInvocations",
      "Invocations",
      "FailedInvocations",
      "TriggeredRules",
      "MatchedEvents",
      "ThrottledRules"
    ],
    Dimensions: ["RuleName"]
  },
  "AWS/Logs": {
    MetricNames: [
      "IncomingBytes",
      "IncomingLogEvents",
      "ForwardedBytes",
      "ForwardedLogEvents",
      "DeliveryErrors",
      "DeliveryThrottling"
    ],
    Dimensions: ["LogGroupName", "DestinationType", "FilterName"]
  },
  "AWS/CodeBuild": {
    MetricNames: [
      "BuildDuration",
      "Builds",
      "DownloadSourceDuration",
      "Duration",
      "FailedBuilds",
      "FinalizingDuration",
      "InstallDuration",
      "PostBuildDuration",
      "PreBuildDuration",
      "ProvisioningDuration",
      "QueuedDuration",
      "SubmittedDuration",
      "SucceededBuilds",
      "UploadArtifactsDuration"
    ],
    Dimensions: ["ProjectName"]
  },
  "AWS/Cognito": {
    MetricNames: [
      "CompromisedCredentialsRisk",
      "AccountTakeOverRisk",
      "OverrideBlock",
      "Risk",
      "NoRisk"
    ],
    Dimensions: ["Operation", "UserPoolId", "RiskLevel"]
  },
  "AWS/Connect": {
    MetricNames: [
      "CallsBreachingConcurrencyQuota",
      "CallBackNotDialableNumber",
      "CallRecordingUploadError",
      "CallsPerInterval",
      "ConcurrentCalls",
      "ConcurrentCallsPercentage",
      "ContactFlowErrors",
      "ContactFlowFatalErrors",
      "LongestQueueWaitTime",
      "MissedCalls",
      "MisconfiguredPhoneNumbers",
      "PublicSigningKeyUsage",
      "QueueCapacityExceededError",
      "QueueSize",
      "ThrottledCalls",
      "ToInstancePacketLossRate"
    ],
    Dimensions: []
  },
  "AWS/DMS": {
    MetricNames: [
      "CPUUtilization",
      "FreeStorageSpace",
      "FreeableMemory",
      "WriteIOPS",
      "ReadIOPS",
      "WriteThroughput",
      "ReadThroughput",
      "WriteLatency",
      "ReadLatency",
      "SwapUsage",
      "NetworkTransmitThroughput",
      "NetworkReceiveThroughput",
      "FullLoadThroughputBandwidthSource",
      "FullLoadThroughputBandwidthTarget",
      "FullLoadThroughputRowsSource",
      "FullLoadThroughputRowsTarget",
      "CDCIncomingChanges",
      "CDCChangesMemorySource",
      "CDCChangesMemoryTarget",
      "CDCChangesDiskSource",
      "CDCChangesDiskTarget",
      "CDCThroughputBandwidthSource",
      "CDCThroughputBandwidthTarget",
      "CDCThroughputRowsSource",
      "CDCThroughputRowsTarget",
      "CDCLatencySource",
      "CDCLatencyTarget"
    ],
    Dimensions: []
  },
  "AWS/DX": {
    MetricNames: [
      "ConnectionState",
      "ConnectionBpsEgress",
      "ConnectionBpsIngress",
      "ConnectionPpsEgress",
      "ConnectionPpsIngress",
      "ConnectionCRCErrorCount",
      "ConnectionLightLevelTx",
      "ConnectionLightLevelRx"
    ],
    Dimensions: ["ConnectionId"]
  },
  "AWS/DocDB": {
    MetricNames: [
      "BackupRetentionPeriodStorageUsed",
      "BufferCacheHitRatio",
      "CPUUtilization",
      "DatabaseConnections",
      "DBInstanceReplicaLag",
      "DBClusterReplicaLagMaximum",
      "DBClusterReplicaLagMinimum",
      "DiskQueueDepth",
      "EngineUptime",
      "FreeableMemory",
      "FreeLocalStorage",
      "NetworkReceiveThroughput",
      "NetworkThroughput",
      "NetworkTransmitThroughput",
      "ReadIOPS",
      "ReadLatency",
      "ReadThroughput",
      "SnapshotStorageUsed",
      "SwapUsage",
      "TotalBackupStorageBilled",
      "VolumeBytesUsed",
      "VolumeReadIOPs",
      "VolumeWriteIOPs",
      "WriteIOPS",
      "WriteLatency",
      "WriteThroughput"
    ],
    Dimensions: ["DBClusterIdentifier", " Role", "DBInstanceIdentifier"]
  },
  "AWS/DynamoDB": {
    MetricNames: [
      "ConditionalCheckFailedRequests",
      "ConsumedReadCapacityUnits",
      "ConsumedWriteCapacityUnits",
      "OnlineIndexConsumedWriteCapacity",
      "OnlineIndexPercentageProgress",
      "OnlineIndexThrottleEvents",
      "PendingReplicationCount",
      "ProvisionedReadCapacityUnits",
      "ProvisionedWriteCapacityUnits",
      "ReadThrottleEvents",
      "ReplicationLatency",
      "ReturnedBytes",
      "ReturnedItemCount",
      "ReturnedRecordsCount",
      "SuccessfulRequestLatency",
      "SystemErrors",
      "TimeToLiveDeletedItemCount",
      "ThrottledRequests",
      "TransactionConflict",
      "UserErrors",
      "WriteThrottleEvents"
    ],
    Dimensions: [
      "GlobalSecondaryIndexName",
      "Operation",
      "ReceivingRegion",
      "StreamLabel",
      "TableName"
    ]
  },
  "AWS/EC2": {
    MetricNames: [
      "CPUCreditUsage",
      "CPUCreditBalance",
      "CPUSurplusCreditBalance",
      "CPUSurplusCreditsCharged",
      "CPUUtilization",
      "DiskReadOps",
      "DiskWriteOps",
      "DiskReadBytes",
      "DiskWriteBytes",
      "NetworkIn",
      "NetworkOut",
      "NetworkPacketsIn",
      "NetworkPacketsOut",
      "StatusCheckFailed",
      "StatusCheckFailed_Instance",
      "StatusCheckFailed_System",
      "EBSReadOps",
      "EBSWriteOps",
      "EBSReadBytes",
      "EBSWriteBytes",
      "EBSIOBalance%",
      "EBSByteBalance%"
    ],
    Dimensions: [
      "AutoScalingGroupName",
      "ImageId",
      "InstanceId",
      "InstanceType"
    ]
  },
  "AWS/EC2Spot": {
    MetricNames: [
      "AvailableInstancePoolsCount",
      "BidsSubmittedForCapacity",
      "EligibleInstancePoolCount",
      "FulfilledCapacity",
      "MaxPercentCapacityAllocation",
      "PendingCapacity",
      "PercentCapacityAllocation",
      "TargetCapacity",
      "TerminatingCapacity"
    ],
    Dimensions: ["AvailabilityZone", "FleetRequestId", "InstanceType"]
  },
  "AWS/AutoScaling": {
    MetricNames: [
      "GroupMinSize",
      "GroupMaxSize",
      "GroupDesiredCapacity",
      "GroupInServiceInstances",
      "GroupPendingInstances",
      "GroupStandbyInstances",
      "GroupTerminatingInstances",
      "GroupTotalInstances"
    ],
    Dimensions: ["AutoScalingGroupName"]
  },
  "AWS/ElasticBeanstalk": {
    MetricNames: [
      "ApplicationLatencyP99.9",
      "InstancesSevere",
      "ApplicationLatencyP90",
      "ApplicationLatencyP99",
      "ApplicationLatencyP95",
      "InstancesUnknown",
      "ApplicationLatencyP85",
      "InstancesInfo",
      "ApplicationRequests2xx",
      "InstancesDegraded",
      "InstancesWarning",
      "ApplicationLatencyP50",
      "ApplicationRequestsTotal",
      "InstancesNoData",
      "InstancesPending",
      "ApplicationLatencyP10",
      "ApplicationRequests5xx",
      "ApplicationLatencyP75",
      "InstancesOk",
      "ApplicationRequests3xx",
      "ApplicationRequests4xx",
      "CPUUser",
      "CPUIdle",
      "RootFilesystemUtil",
      "LoadAverage1min",
      "CPUIrq",
      "CPUNice",
      "CPUIowait",
      "LoadAverage5min",
      "CPUSystem",
      "InstanceHealth",
      "CPUSoftirq"
    ],
    Dimensions: []
  },
  "AWS/EBS": {
    MetricNames: [
      "VolumeReadBytes",
      "VolumeWriteBytes",
      "VolumeReadOps",
      "VolumeWriteOps",
      "VolumeTotalReadTime",
      "VolumeTotalWriteTime",
      "VolumeIdleTime",
      "VolumeQueueLength",
      "VolumeThroughputPercentage",
      "VolumeConsumedReadWriteOps",
      "BurstBalance"
    ],
    Dimensions: ["VolumeId"]
  },
  "AWS/ECS": {
    MetricNames: [
      "CPUReservation",
      "CPUUtilization",
      "MemoryReservation",
      "MemoryUtilization",
      "GPUReservation"
    ],
    Dimensions: ["ClusterName", "ServiceName"]
  },
  "AWS/EFS": {
    MetricNames: [
      "BurstCreditBalance",
      "ClientConnections",
      "DataReadIOBytes",
      "DataWriteIOBytes",
      "MetadataIOBytes",
      "PercentIOLimit",
      "PermittedThroughput",
      "TotalIOBytes"
    ],
    Dimensions: ["FileSystemId"]
  },
  "AWS/ElasticInference": {
    MetricNames: [
      "AcceleratorHealthCheckFailed",
      "ConnectivityCheckFailed",
      "AcceleratorMemoryUsage"
    ],
    Dimensions: ["ElasticInferenceAcceleratorId", "InstanceId"]
  },
  "AWS/ApplicationELB": {
    MetricNames: [
      "ActiveConnectionCount",
      "ClientTLSNegotiationErrorCount",
      "ConsumedLCUs",
      "HTTP_Fixed_Response_Count",
      "HTTP_Redirect_Count",
      "HTTP_Redirect_Url_Limit_Exceeded_Count",
      "HTTPCode_ELB_3XX_Count",
      "HTTPCode_ELB_4XX_Count",
      "HTTPCode_ELB_5XX_Count",
      "HTTPCode_ELB_500_Count",
      "HTTPCode_ELB_502_Count",
      "HTTPCode_ELB_503_Count",
      "HTTPCode_ELB_504_Count",
      "IPv6ProcessedBytes",
      "IPv6RequestCount",
      "NewConnectionCount",
      "ProcessedBytes",
      "RejectedConnectionCount",
      "RequestCount",
      "RuleEvaluations",
      "HealthyHostCount",
      "HTTPCode_Target_2XX_Count, HTTPCode_Target_3XX_Count, HTTPCode_Target_4XX_Count, HTTPCode_Target_5XX_Count",
      "NonStickyRequestCount",
      "RequestCountPerTarget",
      "TargetConnectionErrorCount",
      "TargetResponseTime",
      "TargetTLSNegotiationErrorCount",
      "UnHealthyHostCount",
      "LambdaInternalError",
      "LambdaTargetProcessedBytes",
      "LambdaUserError",
      "ELBAuthError",
      "ELBAuthFailure",
      "ELBAuthLatency",
      "ELBAuthRefreshTokenSuccess",
      "ELBAuthSuccess",
      "ELBAuthUserClaimsSizeExceeded"
    ],
    Dimensions: ["AvailabilityZone", "LoadBalancer", "TargetGroup"]
  },
  "AWS/ELB": {
    MetricNames: [
      "BackendConnectionErrors",
      "HealthyHostCount",
      "HTTPCode_Backend_2XX, HTTPCode_Backend_3XX, HTTPCode_Backend_4XX, HTTPCode_Backend_5XX",
      "HTTPCode_ELB_4XX",
      "HTTPCode_ELB_5XX",
      "Latency",
      "RequestCount",
      "SpilloverCount",
      "SurgeQueueLength",
      "UnHealthyHostCount",
      "EstimatedALBActiveConnectionCount",
      "EstimatedALBConsumedLCUs",
      "EstimatedALBNewConnectionCount",
      "EstimatedProcessedBytes"
    ],
    Dimensions: ["AvailabilityZone", "LoadBalancerName"]
  },
  "AWS/NetworkELB": {
    MetricNames: [
      "ActiveFlowCount",
      "ActiveFlowCount_TLS",
      "ClientTLSNegotiationErrorCount",
      "ConsumedLCUs",
      "HealthyHostCount",
      "NewFlowCount",
      "NewFlowCount_TLS",
      "ProcessedBytes",
      "ProcessedBytes_TLS",
      "TargetTLSNegotiationErrorCount",
      "TCP_Client_Reset_Count",
      "TCP_ELB_Reset_Count",
      "TCP_Target_Reset_Count",
      "UnHealthyHostCount"
    ],
    Dimensions: ["AvailabilityZone", "LoadBalancer", "TargetGroup"]
  },
  "AWS/ElasticTranscoder": {
    MetricNames: [
      "Billed HD Output",
      "Billed SD Output",
      "Billed Audio Output",
      "Jobs Completed",
      "Jobs Errored",
      "Outputs per Job",
      "Standby Time",
      "Errors",
      "Throttles"
    ],
    Dimensions: ["PipelineId", "Operation"]
  },
  "AWS/ElastiCache": {
    MetricNames: [
      "CPUUtilization",
      "FreeableMemory",
      "NetworkBytesIn",
      "NetworkBytesOut",
      "NetworkPacketsIn",
      "NetworkPacketsOut",
      "SwapUsage",
      "ActiveDefragHits",
      "BytesUsedForCache",
      "CacheHits",
      "CacheMisses",
      "CurrConnections",
      "EngineCPUUtilization",
      "Evictions",
      "NewConnections",
      "Reclaimed",
      "ReplicationBytes",
      "ReplicationLag",
      "SaveInProgress",
      "CurrItems",
      "GetTypeCmds",
      "HashBasedCmds",
      "HyperLogLogBasedCmds",
      "KeyBasedCmds",
      "ListBasedCmds",
      "SetBasedCmds",
      "SetTypeCmds",
      "SortedSetBasedCmds",
      "StringBasedCmds",
      "StreamBasedCmds",
      "NewItems",
      "UnusedMemory",
      "BytesUsedForHash",
      "CmdConfigGet",
      "CmdConfigSet",
      "CmdTouch",
      "CurrConfig",
      "EvictedUnfetched",
      "ExpiredUnfetched",
      "SlabsMoved",
      "TouchHits",
      "TouchMisses",
      "BytesReadIntoMemcached",
      "BytesUsedForCacheItems",
      "BytesWrittenOutFromMemcached",
      "CasBadval",
      "CasHits",
      "CasMisses",
      "CmdFlush",
      "CmdGet",
      "CmdSet",
      "DecrHits",
      "DecrMisses",
      "DeleteHits",
      "DeleteMisses",
      "GetHits",
      "GetMisses",
      "IncrHits",
      "IncrMisses"
    ],
    Dimensions: ["CacheClusterId", "CacheNodeId"]
  },
  "AWS/ES": {
    MetricNames: [
      "ClusterStatus.green",
      "ClusterStatus.yellow",
      "ClusterStatus.red",
      "Nodes",
      "SearchableDocuments",
      "DeletedDocuments",
      "CPUUtilization",
      "FreeStorageSpace",
      "ClusterUsedSpace",
      "ClusterIndexWritesBlocked",
      "JVMMemoryPressure",
      "AutomatedSnapshotFailure",
      "CPUCreditBalance",
      "KibanaHealthyNodes",
      "KMSKeyError",
      "KMSKeyInaccessible",
      "InvalidHostHeaderRequests",
      "ElasticsearchRequests",
      "RequestCount",
      "MasterCPUUtilization",
      "MasterFreeStorageSpace",
      "MasterJVMMemoryPressure",
      "MasterCPUCreditBalance",
      "MasterReachableFromNode",
      "ReadLatency",
      "WriteLatency",
      "ReadThroughput",
      "WriteThroughput",
      "DiskQueueDepth",
      "ReadIOPS",
      "WriteIOPS",
      "IndexingLatency",
      "IndexingRate",
      "SearchLatency",
      "SearchRate",
      "SysMemoryUtilization",
      "JVMGCYoungCollectionCount",
      "JVMGCYoungCollectionTime",
      "JVMGCOldCollectionCount",
      "JVMGCOldCollectionTime",
      "ThreadpoolForce_mergeQueue",
      "ThreadpoolForce_mergeRejected",
      "ThreadpoolForce_mergeThreads",
      "ThreadpoolIndexQueue",
      "ThreadpoolIndexRejected",
      "ThreadpoolIndexThreads",
      "ThreadpoolSearchQueue",
      "ThreadpoolSearchRejected",
      "ThreadpoolSearchThreads",
      "ThreadpoolBulkQueue",
      "ThreadpoolBulkRejected",
      "ThreadpoolBulkThreads"
    ],
    Dimensions: ["DomainName", "NodeId", "ClientId"]
  },
  "AWS/ElasticMapReduce": {
    MetricNames: [
      "IsIdle",
      "ContainerAllocated",
      "ContainerReserved",
      "ContainerPending",
      "ContainerPendingRatio",
      "AppsCompleted",
      "AppsFailed",
      "AppsKilled",
      "AppsPending",
      "AppsRunning",
      "AppsSubmitted",
      "CoreNodesRunning",
      "CoreNodesPending",
      "LiveDataNodes",
      "MRTotalNodes",
      "MRActiveNodes",
      "MRLostNodes",
      "MRUnhealthyNodes",
      "MRDecommissionedNodes",
      "MRRebootedNodes",
      "MultiMasterInstanceGroupNodesRunning",
      "MultiMasterInstanceGroupNodesRunningPercentage",
      "MultiMasterInstanceGroupNodesRequested",
      "S3BytesWritten",
      "S3BytesRead",
      "HDFSUtilization",
      "HDFSBytesRead",
      "HDFSBytesWritten",
      "MissingBlocks",
      "CorruptBlocks",
      "TotalLoad",
      "MemoryTotalMB",
      "MemoryReservedMB",
      "MemoryAvailableMB",
      "YARNMemoryAvailablePercentage",
      "MemoryAllocatedMB",
      "PendingDeletionBlocks",
      "UnderReplicatedBlocks",
      "DfsPendingReplicationBlocks",
      "CapacityRemainingGB",
      "HbaseBackupFailed",
      "MostRecentBackupDuration",
      "TimeSinceLastSuccessfulBackup",
      "JobsRunning",
      "JobsFailed",
      "MapTasksRunning",
      "MapTasksRemaining",
      "MapSlotsOpen",
      "RemainingMapTasksPerSlot",
      "ReduceTasksRunning",
      "ReduceTasksRemaining",
      "ReduceSlotsOpen",
      "TaskNodesRunning",
      "TaskNodesPending",
      "LiveTaskTrackers",
      "BackupFailed"
    ],
    Dimensions: ["JobFlowId", "JobId"]
  },
  "AWS/MediaConnect": {
    MetricNames: [
      "ARQRecovered",
      "ARQRequests",
      "ConnectedOutputs",
      "FECPackets",
      "FECRecovered",
      "NotRecoveredPackets",
      "OverflowPackets",
      "PacketLossPercent",
      "RecoveredPackets",
      "RoundTripTime",
      "ContinuityCounter",
      "PATError",
      "PIDError",
      "PMTError",
      "TSByteError",
      "TSSyncLoss",
      "CATError",
      "CRCError",
      "PCRAccuracyError",
      "PCRError",
      "PTSError",
      "TransportError",
      "SourceBitRate"
    ],
    Dimensions: ["Flow ARN", "Availability Zone"]
  },
  "AWS/MediaConvert": {
    MetricNames: [
      "HDOutputSeconds",
      "SDOutputSeconds",
      "UHDOutputSeconds",
      "AudioOutputSeconds",
      "JobsCompletedCount",
      "JobsErroredCount",
      "StandbyTime",
      "TranscodingTime",
      "Errors"
    ],
    Dimensions: ["Queue", "Job", "Operation"]
  },
  "AWS/MediaPackage": {
    MetricNames: [
      "ActiveInput",
      "EgressBytes",
      "EgressRequestCount",
      "EgressResponseTime",
      "IngressBytes",
      "IngressResponseTime"
    ],
    Dimensions: [
      "No Dimension",
      "Channel",
      "IngestEndpoint",
      "OriginEndpoint",
      "StatusCodeRange",
      "PackagingConfiguration"
    ]
  },
  "AWS/MediaTailor": {
    MetricNames: [
      "AdDecisionServer.Ads",
      "AdDecisionServer.Duration",
      "AdDecisionServer.Errors",
      "AdDecisionServer.FillRate",
      "AdDecisionServer.Timeouts",
      "AdNotReady",
      "Avail.Duration",
      "Avail.FilledDuration",
      "Avail.FillRate",
      "GetManifest.Errors",
      "Origin.Errors",
      "Origin.Timeouts"
    ],
    Dimensions: ["Configuration Name"]
  },
  "AWS/FSx": {
    MetricNames: [
      "DataReadBytes",
      "DataWriteBytes",
      "DataReadOperations",
      "DataWriteOperations",
      "MetadataOperations",
      "FreeDataStorageCapacity"
    ],
    Dimensions: ["FileSystemId"]
  },
  "AWS/GameLift": {
    MetricNames: [
      "ActiveInstances",
      "DesiredInstances",
      "IdleInstances",
      "MaxInstances",
      "MinInstances",
      "PercentIdleInstances",
      "InstanceInterruptions",
      "ActiveServerProcesses",
      "HealthyServerProcesses",
      "PercentHealthyServerProcesses",
      "ServerProcessAbnormalTerminations",
      "ServerProcessActivations",
      "ServerProcessTerminations",
      "ActivatingGameSessions",
      "ActiveGameSessions",
      "AvailableGameSessions",
      "PercentAvailableGameSessions",
      "GameSessionInterruptions",
      "CurrentPlayerSessions",
      "PlayerSessionActivations",
      "AverageWaitTime",
      "FirstChoiceNotViable",
      "FirstChoiceOutOfCapacity",
      "LowestLatencyPlacement",
      "LowestPricePlacement",
      "Placement <region name>",
      "PlacementsCanceled",
      "PlacementsFailed",
      "PlacementsStarted",
      "PlacementsSucceeded",
      "PlacementsTimedOut",
      "QueueDepth",
      "CurrentTickets",
      "MatchAcceptancesTimedOut",
      "MatchesAccepted",
      "MatchesCreated",
      "MatchesPlaced",
      "MatchesRejected",
      "PlayersStarted",
      "TicketsFailed",
      "TicketsStarted",
      "TicketsTimedOut",
      "TimeToMatch",
      "TimeToTicketCancel",
      "TimeToTicketSuccess",
      "RuleEvaluationsPassed",
      "RuleEvaluationsFailed"
    ],
    Dimensions: [
      "FleetId",
      "MetricGroup",
      "QueueName",
      "MatchmakingConfigurationName",
      "MatchmakingConfigurationName-RuleName",
      "InstanceType",
      "OperatingSystem"
    ]
  },
  "AWS/Glue": {
    MetricNames: [
      "glue.driver.aggregate.bytesRead",
      "glue.driver.aggregate.elapsedTime",
      "glue.driver.aggregate.numCompletedStages",
      "glue.driver.aggregate.numCompletedTasks",
      "glue.driver.aggregate.numFailedTasks",
      "glue.driver.aggregate.numKilledTasks",
      "glue.driver.aggregate.recordsRead",
      "glue.driver.aggregate.shuffleBytesWritten",
      "glue.driver.aggregate.shuffleLocalBytesRead",
      "glue.driver.BlockManager.disk.diskSpaceUsed_MB",
      "glue.driver.ExecutorAllocationManager.executors.numberAllExecutors",
      "glue.driver.ExecutorAllocationManager.executors.numberMaxNeededExecutors",
      "glue.driver.jvm.heap.usage",
      "glue.executorId.jvm.heap.usage",
      "glue.ALL.jvm.heap.usage",
      "glue.driver.jvm.heap.used",
      "glue.executorId.jvm.heap.used",
      "glue.ALL.jvm.heap.used",
      "glue.driver.s3.filesystem.read_bytes",
      "glue.executorId.s3.filesystem.read_bytes",
      "glue.ALL.s3.filesystem.read_bytes",
      "glue.driver.s3.filesystem.write_bytes",
      "glue.executorId.s3.filesystem.write_bytes",
      "glue.ALL.s3.filesystem.write_bytes",
      "glue.driver.system.cpuSystemLoad",
      "glue.executorId.system.cpuSystemLoad",
      "glue.ALL.system.cpuSystemLoad"
    ],
    Dimensions: ["JobName", "JobRunId", "Type"]
  },
  "AWS/Inspector": {
    MetricNames: [
      "TotalMatchingAgents",
      "TotalHealthyAgents",
      "TotalAssessmentRuns",
      "TotalAssessmentRunFindings"
    ],
    Dimensions: []
  },
  "AWS/IoT": {
    MetricNames: [
      "RulesExecuted",
      "NumLogEventsFailedToPublishThrottled",
      "NumLogBatchesFailedToPublishThrottled",
      "TopicMatch",
      "ParseError",
      "RuleNotFound",
      "RuleMessageThrottled",
      "Success",
      "Failure",
      "Connect.AuthError",
      "Connect.ClientError",
      "Connect.ServerError",
      "Connect.Success",
      "Connect.Throttle",
      "Ping.Success",
      "PublishIn.AuthError",
      "PublishIn.ClientError",
      "PublishIn.ServerError",
      "PublishIn.Success",
      "PublishIn.Throttle",
      "PublishOut.AuthError",
      "PublishOut.ClientError",
      "PublishOut.Success",
      "Subscribe.AuthError",
      "Subscribe.ClientError",
      "Subscribe.ServerError",
      "Subscribe.Success",
      "Subscribe.Throttle",
      "Unsubscribe.ClientError",
      "Unsubscribe.ServerError",
      "Unsubscribe.Success",
      "Unsubscribe.Throttle",
      "DeleteThingShadow.Accepted",
      "GetThingShadow.Accepted",
      "UpdateThingShadow.Accepted",
      "ServerError",
      "ClientError",
      "QueuedJobExecutionTotalCount",
      "InProgressJobExecutionTotalCount",
      "FailedJobExecutionTotalCount",
      "SuccededJobExecutionTotalCount",
      "CanceledJobExecutionTotalCount",
      "RejectedJobExecutionTotalCount",
      "RemovedJobExecutionTotalCount",
      "QueuedJobExecutionCount",
      "InProgressJobExecutionCount",
      "FailedJobExecutionCount",
      "SuccededJobExecutionCount",
      "CanceledJobExecutionCount",
      "RejectedJobExecutionCount",
      "RemovedJobExecutionCount",
      "NonCompliantResources",
      "ResourcesEvaluated",
      "Violations",
      "ViolationsCleared",
      "ViolationsInvalidated"
    ],
    Dimensions: [
      "ActionType",
      "Protocol",
      "RuleName",
      "JobId",
      "CheckName",
      "ScheduledAuditName",
      "SecurityProfileName",
      "BehaviorName"
    ]
  },
  "AWS/IoTAnalytics": {
    MetricNames: [
      "ActionExecution",
      "ActivityExecutionError",
      "IncomingMessages"
    ],
    Dimensions: [
      "ActionType",
      "ChannelName",
      "DatasetName",
      "DatastoreName",
      "PipelineActivityName",
      "PipelineActivityType",
      "PipelineName"
    ]
  },
  "AWS/ThingsGraph": {
    MetricNames: [
      "FlowExecutionTime",
      "FlowExecutionsStarted",
      "FlowExecutionsSucceeded",
      "FlowExecutionsFailed",
      "FlowStepExecutionTime",
      "FlowStepExecutionsStarted",
      "FlowStepExecutionsSucceeded",
      "FlowStepExecutionsFailed",
      "EventStoreQueueSize"
    ],
    Dimensions: ["FlowTemplateId", "SystemTemplateId", "StepName"]
  },
  "AWS/KMS": {
    MetricNames: ["SecondsUntilKeyMaterialExpiration"],
    Dimensions: ["KeyId"]
  },
  "AWS/KinesisAnalytics": {
    MetricNames: [
      "Bytes",
      "KPUs",
      "MillisBehindLatest",
      "Records",
      "Success",
      "InputProcessing.Duration",
      "InputProcessing.OkRecords",
      "InputProcessing.OkBytes",
      "InputProcessing.DroppedRecords",
      "InputProcessing.ProcessingFailedRecords",
      "InputProcessing.Success",
      "LambdaDelivery.OkRecords",
      "LambdaDelivery.DeliveryFailedRecords",
      "LambdaDelivery.Duration"
    ],
    Dimensions: ["Flow", "Id"]
  },
  "AWS/Firehose": {
    MetricNames: [
      "BackupToS3.Bytes",
      "BackupToS3.DataFreshness",
      "BackupToS3.Records",
      "BackupToS3.Success",
      "DataReadFromKinesisStream.Bytes",
      "DataReadFromKinesisStream.Records",
      "DeliveryToElasticsearch.Bytes",
      "DeliveryToElasticsearch.Records",
      "DeliveryToElasticsearch.Success",
      "DeliveryToRedshift.Bytes",
      "DeliveryToRedshift.Records",
      "DeliveryToRedshift.Success",
      "DeliveryToS3.Bytes",
      "DeliveryToS3.DataFreshness",
      "DeliveryToS3.Records",
      "DeliveryToS3.Success",
      "DeliveryToSplunk.Bytes",
      "DeliveryToSplunk.DataAckLatency",
      "DeliveryToSplunk.DataFreshness",
      "DeliveryToSplunk.Records",
      "DeliveryToSplunk.Success",
      "IncomingBytes",
      "IncomingRecords",
      "KinesisMillisBehindLatest",
      "DescribeDeliveryStream.Latency",
      "DescribeDeliveryStream.Requests",
      "ListDeliveryStreams.Latency",
      "ListDeliveryStreams.Requests",
      "PutRecord.Bytes",
      "PutRecord.Latency",
      "PutRecord.Requests",
      "PutRecordBatch.Bytes",
      "PutRecordBatch.Latency",
      "PutRecordBatch.Records",
      "PutRecordBatch.Requests",
      "ThrottledDescribeStream",
      "ThrottledGetRecords",
      "ThrottledGetShardIterator",
      "UpdateDeliveryStream.Latency",
      "UpdateDeliveryStream.Requests",
      "ExecuteProcessing.Duration",
      "ExecuteProcessing.Success",
      "SucceedProcessing.Records",
      "SucceedProcessing.Bytes",
      "SucceedConversion.Records",
      "SucceedConversion.Bytes",
      "FailedConversion.Records",
      "FailedConversion.Bytes"
    ],
    Dimensions: ["DeliveryStreamName"]
  },
  "AWS/Kinesis": {
    MetricNames: [
      "GetRecords.Bytes",
      "GetRecords.IteratorAge",
      "GetRecords.IteratorAgeMilliseconds",
      "GetRecords.Latency",
      "GetRecords.Records",
      "GetRecords.Success",
      "IncomingBytes",
      "IncomingRecords",
      "PutRecord.Bytes",
      "PutRecord.Latency",
      "PutRecord.Success",
      "PutRecords.Bytes",
      "PutRecords.Latency",
      "PutRecords.Records",
      "PutRecords.Success",
      "ReadProvisionedThroughputExceeded",
      "SubscribeToShard.RateExceeded",
      "SubscribeToShard.Success",
      "SubscribeToShardEvent.Bytes",
      "SubscribeToShardEvent.MillisBehindLatest",
      "SubscribeToShardEvent.Records",
      "SubscribeToShardEvent.Success",
      "WriteProvisionedThroughputExceeded",
      "IteratorAgeMilliseconds",
      "OutgoingBytes",
      "OutgoingRecords",
      "PutRecord.Success, PutRecords.Success"
    ],
    Dimensions: ["StreamName", "ShardId"]
  },
  "AWS/KinesisVideo": {
    MetricNames: [
      "PutMedia.Requests",
      "PutMedia.IncomingBytes",
      "PutMedia.IncomingFragments",
      "PutMedia.IncomingFrames",
      "PutMedia.ActiveConnections",
      "PutMedia.ConnectionErrors",
      "PutMedia.FragmentIngestionLatency",
      "PutMedia.FragmentPersistLatency",
      "PutMedia.Latency",
      "PutMedia.BufferingAckLatency",
      "PutMedia.ReceivedAckLatency",
      "PutMedia.PersistedAckLatency",
      "PutMedia.ErrorAckCount",
      "PutMedia.Success",
      "GetMedia.Requests",
      "GetMedia.OutgoingBytes",
      "GetMedia.OutgoingFragments",
      "GetMedia.OutgoingFrames",
      "GetMedia.MillisBehindNow",
      "GetMedia.ConnectionErrors",
      "GetMedia.Success",
      "GetMediaForFragmentList.OutgoingBytes",
      "GetMediaForFragmentList.OutgoingFragments",
      "GetMediaForFragmentList.OutgoingFrames",
      "GetMediaForFragmentList.Requests",
      "GetMediaForFragmentList.Success",
      "ListFragments.Latency",
      "GetHLSStreamingSessionURL.Latency",
      "GetHLSStreamingSessionURL.Requests",
      "GetHLSStreamingSessionURL.Success",
      "GetHLSMasterPlaylist.Latency",
      "GetHLSMasterPlaylist.Requests",
      "GetHLSMasterPlaylist.Success",
      "GetHLSMediaPlaylist.Latency",
      "GetHLSMediaPlaylist.Requests",
      "GetHLSMediaPlaylist.Success",
      "GetMP4InitFragment.Latency",
      "GetMP4InitFragment.Requests",
      "GetMP4InitFragment.Success",
      "GetMP4MediaFragment.Latency",
      "GetMP4MediaFragment.Requests",
      "GetMP4MediaFragment.Success",
      "GetMP4MediaFragment.OutgoingBytes",
      "GetTSFragment.Latency",
      "GetTSFragment.Requests",
      "GetTSFragment.Success",
      "GetTSFragment.OutgoingBytes"
    ],
    Dimensions: []
  },
  "AWS/Lambda": {
    MetricNames: [
      "Invocations",
      "Errors",
      "DeadLetterErrors",
      "Duration",
      "Throttles",
      "IteratorAge",
      "ConcurrentExecutions",
      "UnreservedConcurrentExecutions"
    ],
    Dimensions: ["FunctionName", "Resource", "ExecutedVersion"]
  },
  "AWS/Lex": {
    MetricNames: [
      "RuntimeInvalidLambdaResponses",
      "RuntimeLambdaErrors",
      "MissedUtteranceCount",
      "RuntimePollyErrors",
      "RuntimeRequestCount",
      "RuntimeSucessfulRequestLatency",
      "RuntimeSystemErrors",
      "RuntimeThrottledEvents",
      "RuntimeUserErrors",
      "BotChannelAuthErrors",
      "BotChannelConfigurationErrors",
      "BotChannelInboundThrottledEvents",
      "BotChannelOutboundThrottledEvents",
      "BotChannelRequestCount",
      "BotChannelResponseCardErrors",
      "BotChannelSystemErrors"
    ],
    Dimensions: [
      "BotName",
      " BotAlias",
      " Operation",
      " InputMode",
      " BotVersion",
      "BotAlias",
      " BotChannelName",
      " BotName",
      " Source"
    ]
  },
  "AWS/ML": {
    MetricNames: ["PredictCount"],
    Dimensions: ["RequestMode"]
  },
  "AWS/Kafka": {
    MetricNames: [
      "ZooKeeperRequestLatencyMsMean",
      "ZooKeeperSessionState",
      "ActiveControllerCount",
      "GlobalPartitionCount",
      "GlobalTopicCount",
      "OfflinePartitionsCount",
      "SwapUsed",
      "SwapFree",
      "MemoryUsed",
      "MemoryBuffered",
      "MemoryFree",
      "MemoryCached",
      "CpuUser",
      "CpuSystem",
      "CpuIdle",
      "RootDiskUsed",
      "KafkaAppLogsDiskUsed",
      "KafkaDataLogsDiskUsed",
      "NetworkRxErrors",
      "NetworkTxErrors",
      "NetworkRxDropped",
      "NetworkTxDropped",
      "NetworkRxPackets",
      "NetworkTxPackets",
      "MessagesInPerSec",
      "NetworkProcessorAvgIdlePercent",
      "RequestHandlerAvgIdlePercent",
      "LeaderCount",
      "PartitionCount",
      "ProduceLocalTimeMsMean",
      "ProduceMessageConversionsTimeMsMean",
      "ProduceRequestQueueTimeMsMean",
      "ProduceResponseQueueTimeMsMean",
      "ProduceResponseSendTimeMsMean",
      "ProduceTotalTimeMsMean",
      "RequestBytesMean",
      "UnderMinIsrPartitionCount",
      "UnderReplicatedPartitions",
      "BytesInPerSec",
      "BytesOutPerSec",
      "FetchMessageConversionsPerSec",
      "ProduceMessageConversionsPerSec",
      "FetchConsumerTotalTimeMsMean",
      "FetchFollowerTotalTimeMsMean",
      "FetchConsumerRequestQueueTimeMsMean",
      "FetchFollowerRequestQueueTimeMsMean",
      "FetchConsumerLocalTimeMsMean",
      "FetchFollowerLocalTimeMsMean",
      "FetchConsumerResponseQueueTimeMsMean",
      "FetchFollowerResponseQueueTimeMsMean",
      "FetchConsumerResponseSendTimeMsMean",
      "FetchFollowerResponseSendTimeMsMean",
      "ProduceThrottleTime",
      "ProduceThrottleByteRate",
      "ProduceThrottleQueueSize",
      "FetchThrottleTime",
      "FetchThrottleByteRate",
      "FetchThrottleQueueSize",
      "RequestThrottleTime",
      "RequestTime",
      "RequestThrottleQueueSize",
      "RequestExemptFromThrottleTime"
    ],
    Dimensions: ["Broker", "Topic", "Cluster"]
  },
  "AWS/AmazonMQ": {
    MetricNames: [
      "CpuCreditBalance",
      "CpuUtilization",
      "CurrentConnectionsCount",
      "JournalFilesForFastRecovery",
      "JournalFilesForFullRecovery",
      "HeapUsage",
      "NetworkIn",
      "NetworkOut",
      "OpenTransactionsCount",
      "StorePercentUsage",
      "TotalConsumerCount",
      "TotalMessageCount",
      "TotalProducerCount",
      "ConsumerCount",
      "EnqueueCount",
      "EnqueueTime",
      "ExpiredCount",
      "DispatchCount",
      "DequeueCount",
      "InFlightCount",
      "MemoryUsage",
      "ProducerCount",
      "QueueSize"
    ],
    Dimensions: ["Broker", "Topic or Queue"]
  },
  "AWS/Neptune": {
    MetricNames: [
      "CPUUtilization",
      "ClusterReplicaLag",
      "ClusterReplicaLagMaximum",
      "ClusterReplicaLagMinimum",
      "EngineUptime",
      "FreeableMemory",
      "FreeLocalStorage",
      "GremlinHttp1xx",
      "GremlinHttp2xx",
      "GremlinHttp4xx",
      "GremlinHttp5xx",
      "GremlinErrors",
      "GremlinRequests",
      "GremlinRequestsPerSec",
      "GremlinWebSocketSuccess",
      "GremlinWebSocketClientErrors",
      "GremlinWebSocketServerErrors",
      "GremlinWebSocketAvailableConnections",
      "Http1xx",
      "Http2xx",
      "Http4xx",
      "Http5xx",
      "Http100",
      "Http101",
      "Http200",
      "Http400",
      "Http403",
      "Http405",
      "Http413",
      "Http429",
      "Http500",
      "Http501",
      "LoaderErrors",
      "LoaderRequests",
      "NetworkReceiveThroughput",
      "NetworkThroughput",
      "NetworkTransmitThroughput",
      "SparqlHttp1xx",
      "SparqlHttp2xx",
      "SparqlHttp4xx",
      "SparqlHttp5xx",
      "SparqlErrors",
      "SparqlRequests",
      "SparqlRequestsPerSec",
      "StatusErrors",
      "StatusRequests",
      "VolumeBytesUsed",
      "VolumeReadIOPs",
      "VolumeWriteIOPs"
    ],
    Dimensions: [
      "DBClusterIdentifier",
      " Role",
      "DatabaseClass",
      " EngineName",
      "EngineName"
    ]
  },
  "AWS/OpsWorks": {
    MetricNames: [
      "cpu_idle",
      "cpu_nice",
      "cpu_steal",
      "cpu_system",
      "cpu_user",
      "cpu_waitio",
      "memory_buffers",
      "memory_cached",
      "memory_free",
      "memory_swap",
      "memory_total",
      "memory_used",
      "load_1",
      "load_5",
      "load_15",
      "procs"
    ],
    Dimensions: ["StackId", "LayerId", "InstanceId"]
  },
  "AWS/Polly": {
    MetricNames: [
      "RequestCharacters",
      "ResponseLatency",
      "2XXCount",
      "4XXCount",
      "5XXCount"
    ],
    Dimensions: ["Operation"]
  },
  "AWS/Redshift": {
    MetricNames: [
      "ConcurrencyScalingActiveClusters",
      "ConcurrencyScalingSeconds",
      "CPUUtilization",
      "DatabaseConnections",
      "HealthStatus",
      "MaintenanceMode",
      "MaxConfiguredConcurrencyScalingClusters",
      "NetworkReceiveThroughput",
      "NetworkTransmitThroughput",
      "PercentageDiskSpaceUsed",
      "QueriesCompletedPerSecond",
      "QueryDuration",
      "ReadIOPS",
      "ReadLatency",
      "ReadThroughput",
      "TotalTableCount",
      "WLMQueueLength",
      "WLMQueriesCompletedPerSecond",
      "WLMQueryDuration",
      "WriteIOPS",
      "WriteLatency",
      "WriteThroughput"
    ],
    Dimensions: [
      "latency",
      "NodeID",
      "ClusterIdentifier",
      "Service class",
      "Stage",
      "wmlid"
    ]
  },
  "AWS/RDS": {
    MetricNames: [
      "BinLogDiskUsage",
      "BurstBalance",
      "CPUUtilization",
      "CPUCreditUsage",
      "CPUCreditBalance",
      "DatabaseConnections",
      "DiskQueueDepth",
      "FailedSQLServerAgentJobsCount",
      "FreeableMemory",
      "FreeStorageSpace",
      "MaximumUsedTransactionIDs",
      "NetworkReceiveThroughput",
      "NetworkTransmitThroughput",
      "OldestReplicationSlotLag",
      "ReadIOPS",
      "ReadLatency",
      "ReadThroughput",
      "ReplicaLag",
      "ReplicationSlotDiskUsage",
      "SwapUsage",
      "TransactionLogsDiskUsage",
      "TransactionLogsGeneration",
      "WriteIOPS",
      "WriteLatency",
      "WriteThroughput"
    ],
    Dimensions: [
      "DBInstanceIdentifier",
      "DBClusterIdentifier",
      " Role",
      "DatabaseClass",
      "EngineName",
      "SourceRegion"
    ]
  },
  "AWS/Robomaker": {
    MetricNames: ["RealTimeFactor", "vCPU*", "Memory*", "SimulationUnit*"],
    Dimensions: ["SimulationJobId"]
  },
  "AWS/Route53": {
    MetricNames: [
      "InboundQueryVolume",
      "OutboundQueryVolume",
      "ChildHealthCheckHealthyCount",
      "ConnectionTime",
      "HealthCheckPercentageHealthy",
      "HealthCheckStatus",
      "SSLHandshakeTime",
      "TimeToFirstByte"
    ],
    Dimensions: ["EndpointId", "HealthCheckId"]
  },
  "AWS/SageMaker": {
    MetricNames: [
      "Invocation4XXErrors",
      "Invocation5XXErrors",
      "Invocations",
      "InvocationsPerInstance",
      "ModelLatency",
      "OverheadLatency",
      "CPUUtilization",
      "MemoryUtilization",
      "GPUUtilization",
      "GPUMemoryUtilization",
      "DiskUtilization",
      "DatasetObjectsAutoAnnotated",
      "DatasetObjectsHumanAnnotated",
      "DatasetObjectsLabelingFailed",
      "JobsFailed",
      "JobsSucceeded",
      "JobsStopped",
      "TotalDatasetObjectsLabeled"
    ],
    Dimensions: ["EndpointName", " VariantName", "Host", "LabelingJobName"]
  },
  "AWS/SDKMetrics": {
    MetricNames: [
      "CallCount",
      "ClientErrorCount",
      "EndToEndLatency",
      "ConnectionErrorCount",
      "ServerErrorCount",
      "ThrottleCount"
    ],
    Dimensions: ["DestinationRegion", "Service"]
  },
  "AWS/DDoSProtection": {
    MetricNames: [
      "AllowedRequests",
      "BlockedRequests",
      "CountedRequests",
      "PassedRequests",
      "DDoSDetected",
      "DDoSAttackBitsPerSecond",
      "DDoSAttackPacketsPerSecond",
      "DDoSAttackRequestsPerSecond"
    ],
    Dimensions: ["Rule", "RuleGroup", "WebACL", "Region"]
  },
  "AWS/SES": {
    MetricNames: [
      "Sends",
      "Rejects",
      "Bounces",
      "Complaints",
      "Deliveries",
      "Opens",
      "Clicks",
      "Rendering Failures"
    ],
    Dimensions: []
  },
  "AWS/SNS": {
    MetricNames: [
      "NumberOfMessagesPublished",
      "NumberOfNotificationsDelivered",
      "NumberOfNotificationsFailed",
      "NumberOfNotificationsFilteredOut",
      "NumberOfNotificationsFilteredOut-NoMessageAttributes",
      "NumberOfNotificationsFilteredOut-InvalidAttributes",
      "PublishSize",
      "SMSMonthToDateSpentUSD",
      "SMSSuccessRate"
    ],
    Dimensions: ["Application", "Platform", "Country", "TopicName", "SMSType"]
  },
  "AWS/SQS": {
    MetricNames: [
      "ApproximateAgeOfOldestMessage",
      "ApproximateNumberOfMessagesDelayed",
      "ApproximateNumberOfMessagesNotVisible",
      "ApproximateNumberOfMessagesVisible",
      "NumberOfEmptyReceives",
      "NumberOfMessagesDeleted",
      "NumberOfMessagesReceived",
      "NumberOfMessagesSent",
      "SentMessageSize"
    ],
    Dimensions: ["QueueName"]
  },
  "AWS/S3": {
    MetricNames: [
      "BucketSizeBytes",
      "NumberOfObjects",
      "AllRequests",
      "GetRequests",
      "PutRequests",
      "DeleteRequests",
      "HeadRequests",
      "PostRequests",
      "SelectRequests",
      "SelectScannedBytes",
      "SelectReturnedBytes",
      "ListRequests",
      "BytesDownloaded",
      "BytesUploaded",
      "4xxErrors",
      "5xxErrors",
      "FirstByteLatency",
      "TotalRequestLatency"
    ],
    Dimensions: ["BucketName", "StorageType", "FilterId"]
  },
  "AWS/SWF": {
    MetricNames: [
      "DecisionTaskScheduleToStartTime",
      "DecisionTaskStartToCloseTime",
      "DecisionTasksCompleted",
      "PendingTasks",
      "StartedDecisionTasksTimedOutOnClose",
      "WorkflowStartToCloseTime",
      "WorkflowsCanceled",
      "WorkflowsCompleted",
      "WorkflowsContinuedAsNew",
      "WorkflowsFailed",
      "WorkflowsTerminated",
      "WorkflowsTimedOut",
      "ActivityTaskScheduleToCloseTime",
      "ActivityTaskScheduleToStartTime",
      "ActivityTaskStartToCloseTime",
      "ActivityTasksCanceled",
      "ActivityTasksCompleted",
      "ActivityTasksFailed",
      "ScheduledActivityTasksTimedOutOnClose",
      "ScheduledActivityTasksTimedOutOnStart",
      "StartedActivityTasksTimedOutOnClose",
      "StartedActivityTasksTimedOutOnHeartbeat",
      "ThrottledEvents",
      "ProvisionedBucketSize",
      "ConsumedCapacity",
      "ProvisionedRefillRate"
    ],
    Dimensions: [
      "Domain",
      "ActivityTypeName",
      "ActivityTypeVersion",
      "WorkflowTypeName",
      "WorkflowTypeVersion",
      "APIName",
      "DecisionName",
      "TaskListName"
    ]
  },
  "AWS/States": {
    MetricNames: [
      "ExecutionTime",
      "ExecutionThrottled",
      "ExecutionsAborted",
      "ExecutionsFailed",
      "ExecutionsStarted",
      "ExecutionsSucceeded",
      "ExecutionsTimedOut",
      "ActivityRunTime",
      "ActivityScheduleTime",
      "ActivityTime",
      "ActivitiesFailed",
      "ActivitiesHeartbeatTimedOut",
      "ActivitiesScheduled",
      "ActivitiesStarted",
      "ActivitiesSucceeded",
      "ActivitiesTimedOut",
      "LambdaFunctionRunTime",
      "LambdaFunctionScheduleTime",
      "LambdaFunctionTime",
      "LambdaFunctionsFailed",
      "LambdaFunctionsScheduled",
      "LambdaFunctionsStarted",
      "LambdaFunctionsSucceeded",
      "LambdaFunctionsTimedOut",
      "ServiceIntegrationRunTime",
      "ServiceIntegrationScheduleTime",
      "ServiceIntegrationTime",
      "ServiceIntegrationsFailed",
      "ServiceIntegrationsScheduled",
      "ServiceIntegrationsStarted",
      "ServiceIntegrationsSucceeded",
      "ServiceIntegrationsTimedOut",
      "ThrottledEvents",
      "ProvisionedBucketSize",
      "ProvisionedRefillRate",
      "ConsumedCapacity"
    ],
    Dimensions: [
      "StateMachineArn",
      "ActivityArn",
      "LambdaFunctionArn",
      "ServiceIntegrationResourceArn",
      "StateTransition",
      "APIName"
    ]
  },
  "AWS/StorageGateway": {
    MetricNames: [
      "CacheHitPercent",
      "CachePercentUsed",
      "CachePercentDirty",
      "CloudBytesDownloaded",
      "CloudDownloadLatency",
      "CloudBytesUploaded",
      "UploadBufferFree",
      "CacheFree",
      "UploadBufferPercentUsed",
      "UploadBufferUsed",
      "CacheUsed",
      "QueuedWrites",
      "ReadBytes",
      "ReadTime",
      "TotalCacheSize",
      "WriteBytes",
      "WriteTime",
      "TimeSinceLastRecoveryPoint",
      "WorkingStorageFree",
      "WorkingStoragePercentUsed",
      "WorkingStorageUsed"
    ],
    Dimensions: ["GatewayId", " GatewayName", "VolumeId"]
  },
  "AWS/Textract": {
    MetricNames: [
      "SuccessfulRequestCount",
      "ThrottledCount",
      "ResponseTime",
      "ServerErrorCount",
      "UserErrorCount"
    ],
    Dimensions: []
  },
  "AWS/Translate": {
    MetricNames: [
      "CharacterCount",
      "ResponseTime",
      "ServerErrorCount",
      "SuccessfulRequestCount",
      "ThrottledCount",
      "UserErrorCount"
    ],
    Dimensions: ["LanguagePair", "Operation"]
  },
  "AWS/TrustedAdvisor": {
    MetricNames: [
      "ServiceLimitUsage",
      "RedResources",
      "YellowResources",
      "GreenChecks",
      "RedChecks",
      "YellowChecks"
    ],
    Dimensions: []
  },
  "AWS/NATGateway": {
    MetricNames: [
      "ActiveConnectionCount",
      "BytesInFromDestination",
      "BytesInFromSource",
      "BytesOutToDestination",
      "BytesOutToSource",
      "ConnectionAttemptCount",
      "ConnectionEstablishedCount",
      "ErrorPortAllocation",
      "IdleTimeoutCount",
      "PacketsDropCount",
      "PacketsInFromDestination",
      "PacketsInFromSource",
      "PacketsOutToDestination",
      "PacketsOutToSource"
    ],
    Dimensions: ["NatGatewayId"]
  },
  "AWS/TransitGateway": {
    MetricNames: [
      "BytesIn",
      "BytesOut",
      "PacketsIn",
      "PacketsOut",
      "PacketDropCountBlackhole",
      "PacketDropCountNoRoute"
    ],
    Dimensions: ["TransitGateway"]
  },
  "AWS/VPN": {
    MetricNames: ["TunnelState", "TunnelDataIn", "TunnelDataOut"],
    Dimensions: ["VpnId", "TunnelIpAddress"]
  },
  WAF: {
    MetricNames: [
      "AllowedRequests",
      "BlockedRequests",
      "CountedRequests",
      "PassedRequests",
      "DDoSDetected",
      "DDoSAttackBitsPerSecond",
      "DDoSAttackPacketsPerSecond",
      "DDoSAttackRequestsPerSecond"
    ],
    Dimensions: ["Rule", "RuleGroup", "WebACL", "Region"]
  },
  "AWS/WorkMail": {
    MetricNames: [],
    Dimensions: []
  },
  "AWS/WorkSpaces": {
    MetricNames: [
      "Available1",
      "Unhealthy1",
      "ConnectionAttempt2",
      "ConnectionSuccess2",
      "ConnectionFailure2",
      "SessionLaunchTime2",
      "InSessionLatency2",
      "SessionDisconnect2",
      "UserConnected3",
      "Stopped",
      "Maintenance4"
    ],
    Dimensions: ["DirectoryId", "WorkspaceId"]
  },
  "System/Linux": {
    MetricNames: ["DiskSpaceUtilization"],
    Dimensions: ["InstanceId", "MountPath", "Filesystem"]
  }
};
// Dont remove the comments below
/*
  tables = document.getElementsByTagName("table")
  result = {};
  for(let i = 0; i< tables.length; i++){
    let th = tables[i].getElementsByTagName("th")[0];
    if(th){
      let trs = tables[i].getElementsByTagName("tr");
      let r = [];
      for(let t = 0 ; t < trs.length; t++){
  
        let tds = trs[t].getElementsByTagName("td");
        if(tds.length > 1)
          r.push(tds[0].innerText.trim());
  
      }
  
  
      result[th.innerText] = result[th.innerText] || []
  
      result[th.innerText] = result[th.innerText].concat(r)
    }
  }
  
  JSON.stringify(result,null,4)
  
   */
//# sourceMappingURL=CloudwatchOptions.js.map
